function Aruba({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_540)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
        <path d="M16 32C20.8495 32 25.1947 29.8423 28.1288 26.4348H3.87122C6.8054 29.8423 11.1506 32 16 32Z" fill="#338AF3"/>
        <path d="M32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.1635 0 16C0 17.4442 0.1925 18.8431 0.551188 20.1739H31.4489C31.8075 18.8431 32 17.4442 32 16Z" fill="#338AF3"/>
        <path d="M1.27185 22.261C1.58029 22.9857 1.94085 23.6827 2.34841 24.3479H29.6517C30.0592 23.6827 30.4198 22.9857 30.7284 22.261H1.27185Z" fill="#338AF3"/>
        <path d="M7.3323 10.0915L4.2063 8.71186L7.3323 7.33224L8.71186 4.2063L10.0914 7.33224L13.2174 8.71186L10.0914 10.0915L8.71186 13.2174L7.3323 10.0915Z" fill="#F0F0F0"/>
        <path d="M8.71182 5.9292L9.56376 7.85976L11.4944 8.71182L9.56376 9.56382L8.71182 11.4944L7.85976 9.56382L5.9292 8.71182L7.85976 7.85976L8.71182 5.9292Z" fill="#D80027"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Aruba;
